module.exports = __webpack_public_path__ + "6569311e37bb6e9563154bd736dfb823.svg";